import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.assign";

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import { getStore } from '../../store/store';
import getString from '../../strings/get-string';
import { showConfirmation } from '../../store/device-feature/actions';
import { getMajorOSVersion } from '../../device/operating-system';
import { isAndroid, isIOS } from 'wfui-digital-core/es/lib';
import { execute } from '../../native-app-bridge/native-app-bridge';
import parseResult from '../support/parse-result';
import { getCallbackPromise } from './callbacks';

var getPermissionFailedPayload = function getPermissionFailedPayload(_ref) {
  var _ref$dictated = _ref.dictated,
      dictated = _ref$dictated === void 0 ? false : _ref$dictated;

  if (isAndroid() && getMajorOSVersion() < 6 || isIOS() && getMajorOSVersion() === 7) {
    return {
      message: getString('core.camera.access'),
      showLink: true
    };
  } else if (isAndroid() && getMajorOSVersion() >= 6) {
    if (dictated) {
      return {
        message: getString('core.camera.access'),
        showLink: true
      };
    } else {
      return {
        message: getString('core.camera.enable.android'),
        showLink: false
      };
    }
  } else {
    return {
      message: getString('core.camera.enable'),
      showLink: false
    };
  }
};

var hasPermission = function hasPermission(response) {
  var result = parseResult(response);
  var status = result.status.toLowerCase();

  var _getCallbackPromise = getCallbackPromise(),
      resolve = _getCallbackPromise.resolve,
      reject = _getCallbackPromise.reject;

  var openAppSettings = function openAppSettings(reject) {
    return function () {
      execute('openAppSettings', {});
      reject();
    };
  };

  var cameraPermissionEnhancedWorkflow = false;

  if (window.mwfGlobals.checkDepositCameraPermissionEnhancedWorkflow && ['check deposit', 'check-deposit'].includes(window.mwfGlobals.platformName.toLowerCase()) || window.mwfGlobals.transferMoneyCameraPermissionEnhancedWorkflow && window.mwfGlobals.platformName.toLowerCase() === 'selfpay' || window.mwfGlobals.billpayCameraPermissionEnhancedWorkflow && window.mwfGlobals.platformName.toLowerCase() === 'bill pay') {
    cameraPermissionEnhancedWorkflow = true;
  }

  switch (status) {
    case 'not_determined':
      if (!cameraPermissionEnhancedWorkflow) {
        resolve();
      }

      break;

    case 'granted':
      resolve();
      break;

    case 'denied':
    case 'denied_show_rationale':
      if (!cameraPermissionEnhancedWorkflow) {
        getStore().dispatch(showConfirmation(Object.assign({
          onConfirm: openAppSettings(reject)
        }, getPermissionFailedPayload({
          dictated: false
        }))));
      }

      break;

    case 'denied_dont_ask_again':
      if (!cameraPermissionEnhancedWorkflow) {
        getStore().dispatch(showConfirmation(Object.assign({
          onConfirm: reject
        }, getPermissionFailedPayload({
          dictated: true
        }))));
      }

      break;

    case 'invalid_feature':
    default:
      getStore().dispatch(showConfirmation(Object.assign({
        onConfirm: reject
      }, getPermissionFailedPayload({
        dictated: false
      }))));
      break;
  }
};

export default hasPermission;